module.exports = __webpack_public_path__ + "img/board-star-1st.49e0f8c3.svg";